module.exports = __webpack_public_path__ + "img/intercomscene2.01446c3d.png";